<template>
    <v-container>
        <v-data-table dense :items="items" :headers="headers" hide-default-footer item-key="id"
            loading-text="Загрузка данных..." no-data-text="Нет параметров биллинга"
            class="styled-table pointed-table highlight-last">
            <template v-slot:[`item.value`]="{ item }">
                {{ item.value }}
            </template>
            <template v-slot:[`item.dateBegin`]="{ item }">
                {{ item.dateBegin | dateFormat }}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
export default {
    name: 'BillParametersHistory',

    data() {
        return {
            idColumn: null,
            headers: [
                { text: 'Тариф (руб.)', value: 'value' },
                { text: 'Дата начала', value: 'dateBegin' }
            ],
            items: []
        }
    },

    async created() {
        try {
            this.idColumn = this.$route.params.idColumn;
            this.cargoTypeId = this.$route.params.cargoTypeId;
            const response = await this.axios.get(`/billing/bill-tarif-history/${this.idColumn}/${this.cargoTypeId}`);
            this.items = response.data;
        }
        catch (error) {
            console.error('Error loading billing parameter history:', error);
            this.error = 'Не удалось загрузить данные';
        }
    }
}
</script>

<style scoped>
/* Add this to your component's style or global CSS */
.highlight-last :deep(.v-data-table__wrapper tbody tr:last-child) {
    background-color: #f58634 !important;
    /* Light orange color */
}
</style>